import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkOperationsBar = ({ 
  selectedCount, 
  onBulkStatusUpdate, 
  onBulkNotification, 
  onClearSelection 
}) => {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-fab">
      <div className="bg-surface rounded-lg shadow-modal border border-border p-4">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <Icon name="CheckSquare" size={20} className="text-primary" />
            <span className="text-sm font-body-medium text-text-primary">
              {selectedCount} {selectedCount === 1 ? 'pedido seleccionado' : 'pedidos seleccionados'}
            </span>
          </div>

          <div className="h-6 w-px bg-border"></div>

          <div className="flex items-center space-x-2">
            <div className="relative group">
              <Button
                variant="outline"
                size="sm"
                iconName="Package"
              >
                Cambiar estado
              </Button>
              <div className="absolute bottom-full left-0 mb-2 w-48 bg-surface rounded-lg shadow-modal border border-border opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-micro z-dropdown">
                <div className="py-2">
                  <button
                    onClick={() => onBulkStatusUpdate(selectedCount, 'packed')}
                    className="w-full flex items-center space-x-2 px-4 py-2 text-sm text-text-secondary hover:bg-secondary-50 hover:text-text-primary"
                  >
                    <Icon name="Package" size={16} />
                    <span>Marcar como empaquetado</span>
                  </button>
                  <button
                    onClick={() => onBulkStatusUpdate(selectedCount, 'shipped')}
                    className="w-full flex items-center space-x-2 px-4 py-2 text-sm text-text-secondary hover:bg-secondary-50 hover:text-text-primary"
                  >
                    <Icon name="Send" size={16} />
                    <span>Marcar como enviado</span>
                  </button>
                  <button
                    onClick={() => onBulkStatusUpdate(selectedCount, 'in_transit')}
                    className="w-full flex items-center space-x-2 px-4 py-2 text-sm text-text-secondary hover:bg-secondary-50 hover:text-text-primary"
                  >
                    <Icon name="Truck" size={16} />
                    <span>Marcar en tránsito</span>
                  </button>
                </div>
              </div>
            </div>

            <div className="relative group">
              <Button
                variant="outline"
                size="sm"
                iconName="Mail"
              >
                Notificar
              </Button>
              <div className="absolute bottom-full left-0 mb-2 w-48 bg-surface rounded-lg shadow-modal border border-border opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-micro z-dropdown">
                <div className="py-2">
                  <button
                    onClick={() => onBulkNotification('status_update')}
                    className="w-full flex items-center space-x-2 px-4 py-2 text-sm text-text-secondary hover:bg-secondary-50 hover:text-text-primary"
                  >
                    <Icon name="Mail" size={16} />
                    <span>Actualización de estado</span>
                  </button>
                  <button
                    onClick={() => onBulkNotification('tracking_info')}
                    className="w-full flex items-center space-x-2 px-4 py-2 text-sm text-text-secondary hover:bg-secondary-50 hover:text-text-primary"
                  >
                    <Icon name="MapPin" size={16} />
                    <span>Información de seguimiento</span>
                  </button>
                  <button
                    onClick={() => onBulkNotification('delivery_reminder')}
                    className="w-full flex items-center space-x-2 px-4 py-2 text-sm text-text-secondary hover:bg-secondary-50 hover:text-text-primary"
                  >
                    <Icon name="Bell" size={16} />
                    <span>Recordatorio de entrega</span>
                  </button>
                </div>
              </div>
            </div>

            <Button
              variant="ghost"
              size="sm"
              onClick={onClearSelection}
              iconName="X"
            >
              Limpiar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkOperationsBar;